// Calming tones + the single guide voice for the Get Help Now override.
export const SOUNDS = [
  { id: "tone_432", label: "432 Hz tone", desc: "Grounding, warm resonance", src: "/audio/tone_432.mp3" },
  { id: "tone_528", label: "528 Hz tone", desc: "Soft, restorative hum", src: "/audio/tone_528.mp3" },
  { id: "singing_bowl", label: "Tibetan singing bowl", desc: "Slow, shimmering resonance", src: "/audio/singing_bowl.mp3" },
];
export const DEFAULT_AUDIO = { sound: "tone_528", vol1: 0.4, voiceVol: 1 };

const VOICE = { intro: "/audio/intro.mp3", in: "/audio/cue_in.mp3", hold: "/audio/cue_hold.mp3", out: "/audio/cue_out.mp3" };

let tone = null;
let players = {};
let settings = { ...DEFAULT_AUDIO };
let introHandler = null;

const srcOf = (id) => (SOUNDS.find((s) => s.id === id) || SOUNDS[1]).src;

function ensure() {
  if (!tone) {
    tone = new Audio(srcOf(settings.sound));
    tone.loop = true;
  }
  Object.entries(VOICE).forEach(([k, src]) => {
    if (!players[k]) players[k] = new Audio(src);
  });
  tone.volume = settings.vol1;
  Object.values(players).forEach((p) => (p.volume = settings.voiceVol));
}

export function setAudioSelection(p) {
  const next = { ...DEFAULT_AUDIO, ...p };
  const changed = next.sound !== settings.sound;
  settings = next;
  if (tone && changed) {
    const playing = !tone.paused;
    tone.src = srcOf(settings.sound);
    tone.loop = true;
    if (playing) tone.play().catch(() => {});
  }
  if (tone) tone.volume = settings.vol1;
  Object.values(players).forEach((pl) => (pl.volume = settings.voiceVol));
}

export function startCalmTone() {
  ensure();
  tone.currentTime = 0;
  return tone.play().catch(() => {});
}

export function playIntro(onDone) {
  ensure();
  const intro = players.intro;
  if (introHandler) intro.removeEventListener("ended", introHandler);
  introHandler = () => onDone();
  intro.addEventListener("ended", introHandler, { once: true });
  intro.currentTime = 0;
  intro.play().catch(() => onDone());
}

export function playCue(phase) {
  ensure();
  const p = players[phase];
  if (!p) return;
  p.currentTime = 0;
  p.play().catch(() => {});
}

export function stopEmergencyAudio() {
  [tone, ...Object.values(players)].forEach((p) => {
    if (!p) return;
    p.pause();
    p.currentTime = 0;
  });
  if (introHandler && players.intro) players.intro.removeEventListener("ended", introHandler);
}

let preview = null;
export function previewSound(id, vol = 0.5) {
  stopPreview();
  preview = new Audio(srcOf(id));
  preview.volume = vol;
  preview.play().catch(() => {});
  setTimeout(stopPreview, 6000);
}
export function stopPreview() {
  if (preview) preview.pause();
  preview = null;
}
